exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lotion-header[data-v-6cf3e9cd],.symbol[data-v-6cf3e9cd]{font-size:12px}.lotion-description[data-v-6cf3e9cd]{font-size:11px;margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6cf3e9cd","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ixcms/themes/heartlandtan/src/vue-src/base/_base-portal-left-sidebar.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"optionsId":"0","vue":true,"id":"data-v-6cf3e9cd","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ixcms/themes/heartlandtan/src/vue-src/base/_base-portal-left-sidebar.vue
// module chunks = 24